import styled from 'styled-components';

// #607d8b is CoreUI's input foreground; .text-muted (#b0bec5) is a step lighter
// and reads as disabled next to the row's body text.
export const SubText = styled.span`
  display: block;
  font-size: 0.75rem;
  line-height: 1.125rem;
  color: #607d8b;
`;

export const CellStack = styled.div`
  display: flex;
  flex-direction: column;
  > * + * {
    margin-top: 3px;
  }
`;

export const ReviewMeta = styled.div`
  display: flex;
  align-items: center;
  > * + * {
    margin-left: 8px;
  }
`;

/* Fixed layout so the columns keep the proportions the design specifies instead of
   being redistributed by content width. */
export const TableResponsive = styled.div`
  > table {
    table-layout: fixed;
  }
  > table td {
    word-break: break-word;
  }
`;

export const FilterPanelBody = styled.div`
  > * + * {
    margin-top: 14px;
  }
`;

/* Sits inside the Collapse so the gap to the table disappears with the panel. */
export const FilterPanelInner = styled(FilterPanelBody)`
  padding-bottom: 12px;

  /* Left alone, a checked radio is painted in the OS accent colour (blue on macOS).
     The design specifies #2e333b. */
  .form-check-input {
    accent-color: #2e333b;
    margin-left: -19px;
  }
  /* Bootstrap indents the label 1.25rem; the design puts the text at 19px. */
  .form-check-label {
    padding-left: 19px;
  }
  /* CoreUI's form-control border is rgba(0,0,0,.15), which resolves to #d9d9d9 over
     white; the design specifies the blue-grey #cfd8dc. Scoped so no other filter
     panel in the CMS shifts. */
  .form-control {
    border-color: #cfd8dc;
  }
`;

export const Divider = styled.hr`
  width: 100%;
  margin: 0;
  border-top: 1px solid #cfd8dc;
`;

/* Bootstrap sizes a bare <legend> at 1.5rem, which would tower over the radios. */
export const GroupLegend = styled.legend`
  padding: 0;
  margin-bottom: 8px;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.5;
`;

export const RadioGroupFieldset = styled.fieldset`
  min-width: 0;
  /* .form-check carries the 8px between rows; the group ends flush with its last one. */
  > div:last-child .form-check {
    margin-bottom: 0;
  }
`;

export const RadioRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  > * + * {
    margin-left: 20px;
  }
`;

export const ApplyWrap = styled.div`
  display: flex;
  justify-content: center;
`;

export const SortRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  > * + * {
    margin-left: 12px;
  }
  label {
    margin-bottom: 0;
  }
  /* .form-control is width:100%, which in this flex row lets the two selects eat the
     whole width. The design fixes them at 88 and 145. */
  select[name='per_page'] {
    width: 88px;
  }
  select[name='sort'] {
    width: 145px;
  }
`;
